export default __webpack_public_path__ + "static/media/tarjeta-oh.bc79bcce.bc79bcce.png";